<template>
  <div>
    <div
      v-for="(item, game) in all_game_list"
      :id="'game' + game"
      :key="game"
      class="new-list"
    >
      <div
        v-if="item.direction != 2"
        :id="item.name"
        :ref="game"
        class="game_title"
      >
        <div
          class="game_title_left"
          :class="item.case_tpl_id"
        >
          <img
            :id="item.name"
            :src="item.image"
            alt=""
          ><span v-if="item.pid == 0">{{ item.abbr }}</span>
        </div>
        <div
          v-if="item.direction == 0 && item.id != 1 && item.case_tpl_id != 'case_3' && item.case_tpl_id != 'case_4'"
          class="more"
          @click="$parent.jumpRecent(item)"
        >
          {{ $t("全部") }}
        </div>
      </div>
      <div
        v-else
        :id="item.name"
        class="slots_title"
      >
        {{ $t("所有游戏") }}
      </div>
      <div
        v-if="item.direction == 2"
        class="fake"
      >
        <div class="container">
          <div
            v-for="i in 4"
            :id="i % 2 ? 'right' : 'left'"
            :key="i"
            :class="i % 2 ? 'right' : 'left'"
          >
            <div
              :id="i % 2 ? 'rightWrap' : 'leftWrap'"
              :ref="i % 2 ? 'rightWrap' : 'leftWrap'"
            >
              <div class="item-img">
                <img
                  v-for="(citem, index) in item['children_games'][i]"
                  :key="citem.id"
                  :src="citem.image"
                  alt=""
                  :data-id="citem.id"
                  :data-index="0"
                  @click="handleDynamicClick(i, citem.id)"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="item.direction == 2"
        class="slots-video"
      >
        <img
          style="width: 100%;"
          src="https://cdn.bz999xyz.xyz/image/2024/09/10/46ebb50813fb43c5bb10e3a690ffb32f.avif"
          alt=""
        >
        <div class="video-info">
          GRUPO HMS
        </div>
      </div>
      <div
        v-if="item.direction != 2"
        :class="item.direction == 1 ? 'game-list directionGanme-list' : 'game-list'"
      >
        <div
          v-for="(citem, index) in item.children_games"
          v-show="index < item.step_show"
          :key="index"
          class="game-item"
          :class="item.case_tpl_id"
          @click="
            $parent.playGame(
              citem,
              item
            )
          "
        >
          <div
            v-lazy:background-image="citem.image"
            class="innerbox"
          >
            <div class="link_user">
              <van-icon name="user" />{{ citem.game_num }}
            </div>
            <img
              v-if="citem.is_collect == 1"
              class="like_icon"
              src="../assets/images/category/like_color.png"
              alt=""
              @click.stop="setFavoritos(citem)"
            >
            <img
              v-else
              class="like_icon"
              src="../assets/images/category/like.png"
              alt=""
              @click.stop="setFavoritos(citem)"
            >
            <img
              v-if="!citem.is_works && item.is_game_list == 1"
              src="../assets/images/common/nowork.png"
              class="nowork"
            >
            <div class="game_item_pg_name">
              {{ citem.game_name }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="item.children_games.length > item.step_show"
        class="show_more"
        @click="showMore(item, game)"
      >
        <div>
          {{ $t("待显示") }} {{ item.step_show }} {{ $t("之间的游戏") }} {{ item.children_games.length }} {{
            item.game_name
          }}
          {{ $t("游戏") }}
        </div>
        {{ $t("加载更多") }} ⇊
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Fetch from "../utils/fetch"
export default {
    name: "IndexListHermes",
    props: {
        all_game_list: Array
    },
    data() {
        return {
            gamesPerPage: 8, // 每页显示的游戏数量
            currentPage: 0, // 当前页码
        };
    },
    computed: {
        colletIds() {
            return this.$parent.colletList.map(({ id }) => id)
        },
    },
    watch: {
        all_game_list: {
            deep: true, //深度监听设置为 true
            handler: function (newV, oldV) {
                this.all_game_list = newV;
            }
        }
    },
    mounted() {
        if (this.all_game_list[0].case_tpl_id == 'case_1') {
            this.$nextTick(() => {
                this.autoPlayLeft();
                this.autoPlayRight();
                this.autoPlayLeft1();
                this.autoPlayRight1();
            })
        }

    },
    methods: {
        showMore(item, game) {
            item.step_show += 12
            this.$forceUpdate()
        },
        handleDynamicClick(index, id) {
            let citem = {}, item = {};
            console.log(this.all_game_list)
            citem = this.all_game_list[2];
            citem.children_games[index].forEach(i => {
                if (i.id == id) {
                    item = i;
                }
            })
            this.$parent.playGame(
                item,
                citem
            )
        },
        autoPlayLeft() { //向上轮播 
            var speedup = 1; //初始化速度
            var leftWrap = this.$refs.leftWrap[0]; //如果这里使用上面的方法不行的华，就使用refs来获取也行
            leftWrap.innerHTML += leftWrap.innerHTML; //图片内容*2
            var oImgs = document.getElementsByClassName("item-img");
            leftWrap.style.height = oImgs.length * 200 + "px"; //680 是一张图片高度

            this.timerLeft = setInterval(function () {
                if (leftWrap.offsetTop < -400) { //向上轮播，top移出到一半的时候，重新开始
                    leftWrap.style.top = 0 + "px";
                }
                leftWrap.style.top = leftWrap.offsetTop - speedup + "px";
            }, 40);
        },
        autoPlayLeft1() { //向上轮播 
            var speedup = 1; //初始化速度
            var leftWrap = this.$refs.leftWrap1[0]; //如果这里使用上面的方法不行的华，就使用refs来获取也行
            leftWrap.innerHTML += leftWrap.innerHTML; //图片内容*2
            var oImgs = document.getElementsByClassName("item-img");
            leftWrap.style.height = oImgs.length * 200 + "px"; //680 是一张图片高度

            this.timerLeft = setInterval(function () {
                if (leftWrap.offsetTop < -400) { //向上轮播，top移出到一半的时候，重新开始
                    leftWrap.style.top = 0 + "px";
                }
                leftWrap.style.top = leftWrap.offsetTop - speedup + "px";
            }, 40);
        },
        autoPlayRight() { //向下轮播
            var speeddowm = 1; //初始化速度
            var rightWrap = this.$refs.rightWrap[0];
            rightWrap.innerHTML += rightWrap.innerHTML; //图片内容*2
            var oImgs = document.getElementsByClassName("item-img");
            console.log(oImgs)
            rightWrap.style.height = oImgs.length * 200 + "px";

            this.timerRight = setInterval(function () {
                if (rightWrap.offsetTop >= 0) { //向下轮播，top移动到0的时候从一半的位置继续移动
                    rightWrap.style.top = -400 + "px";
                }
                rightWrap.style.top = rightWrap.offsetTop + speeddowm + "px";
            }, 40);
        },
        autoPlayRight1() { //向下轮播
            var speeddowm = 1; //初始化速度
            var rightWrap = this.$refs.rightWrap1[0];
            rightWrap.innerHTML += rightWrap.innerHTML; //图片内容*2
            var oImgs = document.getElementsByClassName("item-img");
            console.log(oImgs)
            rightWrap.style.height = oImgs.length * 200 + "px";

            this.timerRight = setInterval(function () {
                if (rightWrap.offsetTop >= 0) { //向下轮播，top移动到0的时候从一半的位置继续移动
                    rightWrap.style.top = -400 + "px";
                }
                rightWrap.style.top = rightWrap.offsetTop + speeddowm + "px";
            }, 40);
        },
        pasue(derection) {
            if (derection == "left") {
                clearInterval(this.timerLeft);
            } else {
                clearInterval(this.timerRight);
            }
        },
        play(derection) {
            if (derection == "left") {
                this.autoPlayLeft();
            } else {
                this.autoPlayRight();
            }
        },
        setFavoritos(item) {

            Fetch("/game/collect", {
                game_id: item.id,
                type: 1
            }).then(res => {
                if (res.code == 1) {
                    if (item.is_collect == 1) {
                        item.is_collect = 0;
                    } else {
                        item.is_collect = 1;
                    }
                    console.log(item)
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
@import "../assets/css/variables.less";

.new-list {
    position: relative;
    margin-bottom: 0.3rem;
}

.game_title {
    color: #fff;
    font-size: 0.4rem;
    margin: 0.4rem auto 6px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;
    box-sizing: border-box;

    .game_title_left {
        display: flex;
        align-items: center;
    }

    .game_title_right {
        display: flex;
        align-items: center;

        div {
            padding: .1rem .2rem;
            background-color: #ffffff14;
            border-radius: .2rem;
            margin-left: .1rem;
            font-size: .35rem;
        }
    }

    .more {
        font-size: 12px;
        color: @textcolor3;
    }

    img {
        width: 0.7rem;
        margin-right: 4px;
    }
}

.game-list {
    width: 95%;
    margin: 0.2rem auto 0rem auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-start;
}

.new-list .directionGanme-list {
    width: 100%;
    overflow-x: auto;
    display: block;
    white-space: nowrap;
    overflow-y: hidden;
    /* 隐藏纵向滚动条 */
    scrollbar-width: none;
    /* Firefox 隐藏滚动条 */
    -ms-overflow-style: none;
    /* IE/Edge 隐藏滚动条 */

    .game-item {
        // width: ;
        width: 3rem;
        display: inline-block;
    }
}

.directionGanme-list::-webkit-scrollbar {
    display: none;
}

::-webkit-scrollbar {
    // width: 0 !important;
}

.game-item {
    width: 33.3%;
    //height: 3.5rem;
    margin-bottom: 0.3rem;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
}

.innerbox {
    width: 2.8rem;
    height: 3.7rem;
    position: relative;
    margin: 0 auto;
    overflow: hidden;
    background-size: 100% 100%;
    background-color: rgba(0, 0, 0, .2);
    border-radius: .25rem;
    box-sizing: border-box;

    .like_icon {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 4px;
        right: 4px;
        z-index: 1;
    }

    // .bgImg {
    //   width: 2.8rem;
    //   height: 3.7rem;
    // }
    .good {
        width: 0.6rem;
    }
}

.slots-video {
    width: 95%;
    margin: 0 auto;
    margin-top: .4rem;
    position: relative;

    .video-info {
        position: absolute;
        z-index: 1;
        left: 0;
        bottom: 0;
        color: #fff;
        padding: 0 0 .5rem .875rem;
        font-size: .5rem;
        font-weight: 700;
    }

    img {
        border-radius: .3rem;
    }
}



.nowork {
    width: 100%;
    position: relative;
    z-index: 1;
    background: rgba(0, 0, 0, 0.34);
    margin: 0 auto;
    border-radius: 0.25rem;
}

.game_item_pg_name {
    color: #fff;
    text-align: center;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    //margin: 0 auto;
    width: 100%;
    font-size: 10px;
    font-weight: 500;
    left: 0;
    bottom: 0;
    height: 0.7rem;
    // line-height: 0.5rem;
}

.show_more {
    color: @anttextcolor;
    width: 95%;
    margin: 0 auto;
    border-radius: 0.2rem;
    text-align: center;
    font-size: 11px;

    div {
        height: 0.5rem;
        line-height: 0.5rem;
        color: @textcolor3;
    }
}

.game-list .case_2 {
    width: 25%;
    margin-bottom: .3rem;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;
}

.new-list {
    .game-list.case_5game-list {
        display: grid;
        gap: 0.2rem;
        grid-template-columns: repeat(4, 1fr);

        .game-item {
            width: 100%;

            .innerbox {
                width: 2.1rem;
                height: 3rem;
            }
        }
    }
}

.game-list .case_2 .innerbox {
    width: 95%;
    padding-bottom: 95%;
    height: 0;
    position: relative;
    background-size: 100% 100%;
    background-color: rgba(0, 0, 0, .2);
    border-radius: .25rem;
    box-sizing: border-box;
    margin: 0 auto 20px;
}

.slots_title {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: @textcolor1;
    font-size: 0.5rem;
    text-align: center;
    height: 1rem;
    padding-top: .5rem;
    border-top: 0.01rem solid @anttextcolor;
    margin-top: .3rem;
}

.slots_title::before {
    background-image: linear-gradient(90deg, rgba(0, 0, 0, .01) 0, @textcolor1);
    margin-right: .225rem;
    content: "";
    width: 2.5rem;
    height: 0.05rem;
}

.slots_title::after {
    background-image: linear-gradient(90deg, @textcolor1 0, rgba(0, 0, 0, .01));
    margin-left: .225rem;
    content: "";
    width: 2.5rem;
    height: 0.05rem;
}

.directionGanme-list .innerbox {
    width: 2.5rem;
}

.fake {
    width: 100%;
    height: 400px;

    .container {
        position: relative;
        display: flex;
        justify-content: center;
        padding-right: 10px;

        .left {
            display: inline-block;
            // width: 49%;
            height: 400px;
            // padding-left: 10px;
            margin-left: .2rem;
            box-sizing: border-box;

            img {
                width: 100%;
                margin-bottom: 10px;
                border-radius: .2rem;
            }
        }

        .right {
            display: inline-block;
            // width: 49%;
            // padding-left: 10px;
            margin-left: .2rem;

            box-sizing: border-box;

            img {
                width: 100%;
                margin-bottom: 10px;
                border-radius: .2rem;
            }
        }
    }

    #right {
        width: 23%;
        height: 400px;
        position: relative;
        overflow: hidden;

        #rightWrap {
            position: absolute;
            top: -400px;
            overflow: hidden;

            #rightWrap div {
                float: left;
                width: 100%;
                // height: 150px;

                img {
                    width: 100%;

                }
            }
        }
    }

    #left {
        width: 23%;
        height: 400px;
        position: relative;
        overflow: hidden;

        #leftWrap {
            position: absolute;
            // overflow-y: auto;

            #leftWrap div {
                float: left;
                width: 100%;
                // height: 150px;

                img {
                    width: 100%;

                }
            }
        }
    }
}

.case_3 {
    img#Promoção {
        width: 0.5rem;
        height: 0.5rem;
    }

    img#PG {
        width: 1.5rem;
    }

    img#PP {
        width: 1.5rem;
    }

    img#TADA {
        width: 1.5rem;

    }

    img#JDB {
        width: 1.5rem;
    }

    img#CP {
        width: 1.5rem;
    }

    img#JILI {
        width: 1.5rem;
    }
}

.case_2 {
    img#Promoção {
        width: 0.5rem;
        height: 0.5rem;
    }

    img#PG {
        width: 1.5rem;
    }

    img#PP {
        width: 2rem;
    }

    img#TADA {
        width: 1.5rem;

    }

    img#JDB {
        width: 1rem;
        height: 0.5rem;
    }

    img#CP {
        width: 1.5rem;
    }

    img#JILI {
        width: 1.5rem;
    }
}

.link_user {
    box-sizing: border-box;
    background-color: #ff0000;
    width: 0.9rem;
    color: #fff;
    padding-top: .1rem;
    padding-bottom: .1rem;
    font-size: .24rem;
    text-align: center;
    border-radius: .2rem;
}

.case_1 {
    img#Jogos\ Novos {
        width: 0.6rem;
        height: 0.6rem;
    }

    img#Promoção {
        width: 0.5rem;
        height: 0.5rem;
    }

    img#PG {
        width: 2rem;
    }

    img#PP {
        width: 2rem;
    }

    img#TADA {
        width: 2rem;

    }

    img#JDB {
        width: 1.5rem;
    }

    img#CP {
        width: 2rem;
    }

    img#JILI {
        width: 1.5rem;
    }
}
</style>